export default __webpack_public_path__ + "static/suhail-fecc32303a8b606989e8077ef000cd3a.jpeg";